import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGetSection() {
  const features = ['The "Magnesium Fix" for instant anxiety relief.', 'The 15-minute "Sovereignty Kitchen" meal structure.', 'The "Cortisol-Kill" 2-minute morning routine.', 'Full 30-Day Action Calendar.'];
  return <section className="bg-sage-light py-24 px-6 overflow-hidden" data-id="element-122">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-16" data-id="element-123">
        {/* Image */}
        <div className="flex-1 relative" data-id="element-124">
          <div className="absolute inset-0 bg-cream rounded-full blur-3xl opacity-60 transform -translate-x-10 -translate-y-10" data-id="element-125"></div>
          <img src="https://cdn.magicpatterns.com/uploads/ayQrPTTdoLPgAXL3Mt5A7E/Mockup_HS.jpg" alt="Hormonal Sovereignty Digital Protocol" className="relative z-10 w-full max-w-md mx-auto lg:max-w-full h-auto object-contain drop-shadow-xl" data-id="element-126" />
        </div>

        {/* Content */}
        <div className="flex-1" data-id="element-127">
          <h2 className="text-4xl md:text-5xl mb-4" data-id="element-128">What You Get Today</h2>
          <p className="text-xl text-olive-light font-heading italic mb-8" data-id="element-129">
            Instant Access to the Digital Protocol
          </p>

          <div className="bg-cream p-8 md:p-10 rounded-3xl shadow-sm border border-sage/20" data-id="element-130">
            <h3 className="text-2xl font-bold mb-2 font-body text-olive-gold" data-id="element-131">
              "Hormonal Sovereignty: The 35-60 Protocol"
            </h3>
            <p className="text-warm-dark/70 mb-8 pb-8 border-b border-sage/20" data-id="element-132">
              A complete, no-fluff, 60-page digital manual that contains:
            </p>

            <ul className="space-y-5" data-id="element-133">
              {features.map((feature, index) => <li key={index} className="flex items-start gap-4" data-id="element-134">
                  <CheckCircle2 className="w-6 h-6 text-sage flex-shrink-0 mt-0.5" data-id="element-135" />
                  <span className="text-lg text-warm-dark leading-relaxed" data-id="element-136">
                    {feature}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}